import { WlTransactionType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export { WlTransactionType };

export const wlTransactionTypeDictionary = createSimpleDictionary([
    { id: WlTransactionType.NewBet, name: 'dictionaries.wlTransactionType.newBet' },
    { id: WlTransactionType.AcceptBet, name: 'dictionaries.wlTransactionType.acceptBet' },
    { id: WlTransactionType.FailedBet, name: 'dictionaries.wlTransactionType.failedBet' },
    { id: WlTransactionType.ChangeStatus, name: 'dictionaries.wlTransactionType.changeStatus' },
    { id: WlTransactionType.UnsetBet, name: 'dictionaries.wlTransactionType.unsetBet' },
]);
